import {
  Text,
  Button,
  Link,
  Primary14ExtendedRegular,
  GreyGrey100,
  GreyGrey80,
  PrimaryHeader32Regular,
  AuthUI
} from '@sequencehq/core-components'

export const LinkExpiredPage = () => {
  return (
    <AuthUI.Section gap="24px">
      <AuthUI.Section gap="8px">
        <Text
          {...PrimaryHeader32Regular}
          textAlign="left"
          color={GreyGrey100}
          marginBottom="0px"
        >
          Your sign in link has expired
        </Text>
        <Text {...Primary14ExtendedRegular} color={GreyGrey80}>
          The link you are trying to use has expired. Please try again by
          requesting a new link.
        </Text>
      </AuthUI.Section>
      <Link
        to="/login"
        _hover={{
          textDecoration: 'none'
        }}
      >
        <Button
          variant="primary"
          fullWidth
          size="40px"
          style={{ fontSize: '14px', borderRadius: '8px' }}
        >
          Try again
        </Button>
      </Link>
    </AuthUI.Section>
  )
}

export default LinkExpiredPage
